import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


export default function RoundedBox(props) {
    const { children, className } = props;

    return (
        <div
            className={classNames(
                'rounded-lg bg-certego-darkgray text-certego-white w-100 text-center py-6 px-3',
                className,
            )}
        >
            {children}
        </div>
    );
}

RoundedBox.defaultProps = {
    children: null,
    className: null,
};

RoundedBox.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
